"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var mobx_react_1 = require("mobx-react");
var Error_1 = require("./Error");
var Spinner_1 = require("office-ui-fabric-react/lib/Spinner");
var defaultOnRenderDone = function (props) {
    return null;
};
var defaultOnRenderSync = function (props) {
    return React.createElement(Spinner_1.Spinner, { className: "sync-spinner", label: props.syncLabel || "Loading..." });
};
var defaultOnRenderError = function (error) {
    return React.createElement(Error_1.Error, { className: "sync-error", error: error });
};
var DefaultSyncProps = {
    sync: null,
    onRenderDone: defaultOnRenderDone,
    onRenderSync: defaultOnRenderSync,
    onRenderError: defaultOnRenderError
};
exports.DefaultSyncProps = DefaultSyncProps;
var SyncError = /** @class */ (function (_super) {
    __extends(SyncError, _super);
    function SyncError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SyncError.prototype.render = function () {
        var error = this.props.sync.error;
        return this.props.onRenderError ?
            this.props.onRenderError(error, this.props) :
            DefaultSyncProps.onRenderError(error, this.props);
    };
    return SyncError;
}(React.Component));
var SyncSyncing = /** @class */ (function (_super) {
    __extends(SyncSyncing, _super);
    function SyncSyncing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SyncSyncing.prototype.render = function () {
        return this.props.onRenderSync ?
            this.props.onRenderSync(this.props) :
            DefaultSyncProps.onRenderSync(this.props);
    };
    return SyncSyncing;
}(React.Component));
var Sync = /** @class */ (function (_super) {
    __extends(Sync, _super);
    function Sync() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sync.prototype.render = function () {
        var content;
        var sync = this.props.sync;
        if (sync.syncing) {
            content = React.createElement(SyncSyncing, __assign({}, this.props));
        }
        else if (sync.error) {
            content = React.createElement(SyncError, __assign({}, this.props));
        }
        else if (sync.hasSynced) {
            content = this.props.onRenderDone(this.props);
        }
        else {
            content = this.props.onRenderDefault ? this.props.onRenderDefault(this.props) : null;
        }
        return content;
    };
    Sync = __decorate([
        mobx_react_1.observer
    ], Sync);
    return Sync;
}(React.Component));
exports.Sync = Sync;
